import * as constants from './constants';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import reducer from './reducer';
import KycGrid from './components/KycGrid';

export default {
    constants, reducer, actions, actionTypes,
    KycGrid
}